/* eslint-disable no-undef */

/**
 * Read-only map tooltip. Unlike an InfoWindow, it cannot steal the pointer from the marker or
 * polyline that opened it (which would trigger mouseout/close/mouseover/open in a loop).
 */
export class HoverTooltip {
  constructor() {
    this.position = null;
    this.element = document.createElement("div");
    this.element.className = "map-hover-tooltip";
    this.element.setAttribute("role", "tooltip");
    this.element.style.pointerEvents = "none";

    // Construct only after Maps has loaded, just like the map's other overlays.
    this.overlay = new google.maps.OverlayView();
    this.overlay.onAdd = () => this.overlay.getPanes().floatPane.appendChild(this.element);
    this.overlay.draw = () => this.draw();
    this.overlay.onRemove = () => this.element.remove();
  }

  /** The callers supply formatted HTML with escaped dynamic text. */
  setContent(html) {
    this.element.innerHTML = html;
  }

  setPosition(position) {
    this.position = position;
    this.draw();
  }

  open(map) {
    if (this.overlay.getMap() !== map) {
      this.overlay.setMap(map);
    }
    this.draw();
  }

  draw() {
    const projection = this.overlay.getProjection();
    if (!this.overlay.getMap() || !projection || !this.position) {
      return;
    }
    const point = projection.fromLatLngToDivPixel(this.position);
    if (point) {
      this.element.style.left = `${point.x}px`;
      this.element.style.top = `${point.y}px`;
    }
  }

  close() {
    this.overlay.setMap(null);
  }
}
